import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

const Sidebar = (props) => {
    const [menuModule, setMenuModule] = useState([]);
    const [paramUser, setParamUser] = useState([]);
    const [paramModuleUser, setParamModuleUser] = useState([]);
    useEffect(() => {
        const menu = props.menu;
        const param = JSON.parse(localStorage.getItem('param'));
        const paramModule = JSON.parse(localStorage.getItem('paramModule'));
        if (menu) {
            setMenuModule(menu);
        }
        setParamUser(param);
        setParamModuleUser(paramModule);
    }, [props])
    return (
        <>
            {
                menuModule !== null
                    ?
                    <aside className="main-sidebar sidebar-dark-primary elevation-4">
                        <Link to={"/empresa/modulos/" + paramModuleUser} className="brand-link">
                            <span className="brand-text font-weight-light">
                                <button type="button" className="btn btn-block btn-info">Módulos <span className="info-box-icon"><i className="fas fa-th-large"></i></span></button>
                            </span>
                        </Link>
                        <div className="sidebar">
                            <nav className="mt-2">
                                <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                                    {Object.entries(menuModule).map(([key, subject], i) => (
                                        <li key={i} className="nav-item">
                                            <Link to={subject.path + paramUser} className="nav-link">
                                                <i className={subject.icon}></i>
                                                <p>
                                                    {subject.name}
                                                </p>
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                        </div>
                    </aside>
                    : <div></div>
            }
        </>
    )
}
export default Sidebar
